import { useEffect, useRef } from 'react'

// `useFloatingSelect` also closes on a wysiwyg focus without `onClose`, so `isOpen` itself is watched.
export function useGretaAIChatPopoverClose({ isOpen, onClose }) {
  const isOpenRef = useRef(isOpen)

  useEffect(() => {
    if (isOpenRef.current && !isOpen) {
      onClose()
    }

    isOpenRef.current = isOpen
  }, [isOpen])

  useEffect(
    () => () => {
      if (isOpenRef.current) {
        onClose()
      }
    },
    []
  )
}
